import { 
  ThunkAction, 
  ThunkDispatch 
}                                   from 'redux-thunk';
import { AppState }                 from '../../../../store';
import { AnyAction }                from 'redux';
import megatron                     from '../../../../../utils/megatron/megatron';
import { IOfferState }              from './types';
import { 
  TRAVELLER_DETAILS_API_CALLED,
  UPDATE_HYDRA_SEGMENT, 
  UPDATE_LOYALTY_INFO, 
  UPDATE_TRAVELLER_DETAILS, 
  UPDATE_USER_GOCASH, 
  UPDATE_USER_UUID
}                                   from '../../SearchPage/redux/action-types';
import { travellerInformationApi }  from '../../../config/constants';
import { sendEventOnError }         from '../../../config/omni';

interface offersInteface {
  data  : IOfferState;
}

export const fetchHomePageOffers = (): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const url = 'https://voyager.goibibo.com/api/v1/pagemaker/get_personalized_chunk_offers_data/?chunk=home_carousel&vertical=gocars&flavour=v3&include_fields=&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app';
    try {
      const response: offersInteface = await megatron({
        name: 'carsHomePageGetOffersApi',
        type: 'GET',
        credentials: 'same-origin',
        url,
      });
      dispatch({
        type: 'UPDATE_OFFERS',
        offers: response?.data || []
      });
    } catch (err) {
      console.info("Error fetching homepage offers");
    }
  };
};

export const fetchHomeTemplate = (): ThunkAction<
  void,
  AppState,
  {},
  AnyAction
> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const url = 'https://voyager.goibibo.com/api/v1/pagemaker/get_rendered_template/?template_ids=["gocars_page_config_production"]';
    try {
      const response: offersInteface = await megatron({
        name        : 'carsHomePageGetOffersApi',
        type        : 'GET',
        credentials : 'same-origin',
        url,
      });
      dispatch({
        type: 'UPDATE_TEMPLATE',
        template: response?.data?.['gocars_page_config_production']?.template?.homepage?.dweb || {}
      });
    } catch (err) {
      console.info("Error fetching homepage template");
    }
  };
};

export const getTravellerInformation = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (
    dispatch: ThunkDispatch<AppState, {}, AnyAction>,
    getState: () => AppState
  ) => {
    const { home = {}, review = {} } = getState();

    if (review?.travellerDetails?.first_name?.length && review?.travellerDetails?.gender?.length && review?.travellerDetails?.email?.length && review?.travellerDetails?.phone_number?.length && home?.hydraSegments && Object.keys(home?.hydraSegments)?.length && home?.loyalty_info) return

    const url = `${__ENV_CONFIG__["__GOCARS__"]}${travellerInformationApi}`;
    const headers = {
      Authorization: "Basic Zm9vOmJhcg==",
      "content-type": "application/json",
    };

    dispatch({
      type: TRAVELLER_DETAILS_API_CALLED,
      travellerDetailsCalled: false
    })

    try {
      const response = await megatron({
        name: "carsuserdetails",
        type: "GET",
        credentials: 'include',
        url,
        headers
      });

      if (response?.first_name?.length && response?.last_name?.length) {
        const name = response?.first_name + " " + response?.last_name
        response["first_name"] = name
        response["last_name"] = ""
      }

      if (!response?.gender?.length) {
        response["gender"] = "M"
      }

      if (response?.segments && Object.keys(response?.segments)?.length) {
        dispatch({
          type: UPDATE_HYDRA_SEGMENT,
          hydraSegments: response?.segments
        });

        delete response["segments"]
      }

      if (response?.uuid?.length) {
        dispatch({
          type: UPDATE_USER_UUID,
          uuid: response?.uuid
        });

        delete response["uuid"]
      }

      if (response?.loyalty?.tierNumber >= 0 && response?.loyalty?.status) {
        dispatch({
          type: UPDATE_LOYALTY_INFO,
          loyalty: response?.loyalty
        });

        delete response["loyalty"]
      }

      if (response?.gocash_bal?.length) {
        dispatch({
          type: UPDATE_USER_GOCASH,
          gocash_bal: response?.gocash_bal
        });

        delete response["gocash_bal"]
      }

      dispatch({
        type: UPDATE_TRAVELLER_DETAILS,
        travellerDetails: response,
      });

      dispatch({
        type: TRAVELLER_DETAILS_API_CALLED,
        travellerDetailsCalled: true
      })

    } catch (err) {
      sendEventOnError([{
        field: `traveller_information_error`,
        message: err
      }])
      dispatch({
        type: TRAVELLER_DETAILS_API_CALLED,
        travellerDetailsCalled: true
      })
    }
  };
};
